import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <h1>🤖 Frequently Asked Questions Management</h1>
      <p>Управление базой знаний AI Slack бота</p>
    </div>
  );
};

export default Header; 